export const parseWalletAddress = (address: string) => {
  const firstHalfLength = address.slice(0, 6);
  const secondHalfLength = address.slice(-4);
  return {
    text: `${firstHalfLength}...${secondHalfLength}`,
    full: address,
    start: firstHalfLength,
    end: secondHalfLength,
    link: `https://polygonscan.com/address/${address}`,
  };
};
